import { FeatureFlag } from '../FeatureFlag';

export const locatesV2UserOnlyFiltering = new FeatureFlag({
    key: 'locates-v2-user-only-filtering',
    createdOn: '2025-12-11',
    defaultValue: false,
});
